export default __webpack_public_path__ + "static/media/products-7-m.76c2ceac.webp";